import { useWeb3 } from '@/hooks/use-web3';
import { useEffect, useState } from 'react';
import PortfolioCard from './card/PortfolioCard';
import { Box, Typography, useTheme } from '@mui/material';
import { holdsList } from '@/api/staking/read';
import { ResUserPoolListWithUsdtType } from '@/types/staking/read';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function Holdings() {
  const [list, setList] = useState<ResUserPoolListWithUsdtType[] | null>(null);
  const theme = useTheme();
  const [address, setAddress] = useState('');

  const { isConnected } = useWeb3AuthConnect();
  const { address: addr } = useWeb3();

  // const [wallet, setWallet] = useRecoilState(walletState);
  useEffect(() => {
    if (list) {
      return;
    }
    (async () => {
      if (isConnected && addr) {
        setAddress(addr);
        await setHoldsList(addr);
      }
    })();

    return () => {};
  }, [isConnected, addr]);

  const setHoldsList = async (aAddress: string) => {
    const re = await holdsList(aAddress);
    setList(re.data);
  };
  // const setHoldList = async (aList: EvmTxHistory[], aPools: string[]) => {
  //   const seen = new Set();

  //   const filter = aList.filter((item: EvmTxHistory) => {
  //     if (item.isError === '0' && item.functionName.startsWith('stakeToken')) {
  //       const temp = item.to;
  //       return seen.has(temp) ? false : seen.add(temp);
  //     }
  //     return false;
  //   });
  //   const arr = [];
  //   for (const iterator of aPools) {
  //     for (let i = 0; i < filter.length; i++) {
  //       const iter = filter[i];

  //       if (iter.to.toLowerCase() === iterator.toLowerCase()) {
  //         const re = await web3authCall!.getStakingCall().state(iterator);
  //         const res = await web3authCall!.getStakingCall().getPoolDetails(iterator);
  //         const stateDetail: ResGetStakeCall = await web3authCall!.callStaking(GETSTAKE, iter.to, [
  //           iter.from,
  //           String(i),
  //         ]);
  //         const obj = {
  //           ...iter,
  //           state: re,
  //           ...res,
  //           contractAddr: iter.to,
  //           amountStaked: stateDetail.amountStaked,
  //         };
  //         arr.push(obj);
  //       }
  //     }
  //   }
  //   setList(arr);
  // };
  return (
    <>
      {address ? (
        <Box
          sx={{
            padding: { xs: '16px 24px', md: '20px 24px' },
            maxWidth: '1680px',
          }}
        >
          <Box>
            <Typography color={theme.greyscale.darkgrey2} variant={'h3'}>
              Holdings
            </Typography>
          </Box>
          <Box
            sx={{
              paddingTop: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: {
                xs: '16px',
                md: '10px',
              },
            }}
          >
            {list &&
              list.map((pool) => (
                <PortfolioCard
                  key={pool.poolId}
                  poolId={pool.poolId}
                  contractAddr={pool!.contractAddr}
                  title={pool.title}
                  symbol={pool.symbol}
                  interestRate={pool.interestRate}
                  state={pool.state}
                  usdt={pool.usdt}
                  address={address}
                />
              ))}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            padding: { xs: '16px 24px', md: '20px 24px' },
          }}
        >
          <Typography variant="h3" color={theme.greyscale.darkgrey2}>
            Holdings
          </Typography>
          <Box
            sx={{
              marginTop: '24px',
              background: '#357AFF1A',
              borderRadius: '10px',
              padding: '10px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              No holdings displayed yet
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
